module.exports = __webpack_public_path__ + "files/21151ed5a67066748c31b65c85406c7c.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji/emojilarge.png
// module id = 423
// module chunks = 60